/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_Logon_NameInputs */

const en_tables_skill_groups_logon_name = /** @type {(inputs: Tables_Skill_Groups_Logon_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups Logon Name`)
};

const de_tables_skill_groups_logon_name = /** @type {(inputs: Tables_Skill_Groups_Logon_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldename`)
};

/**
* | output |
* | --- |
* | "Groups Logon Name" |
*
* @param {Tables_Skill_Groups_Logon_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_logon_name = /** @type {((inputs?: Tables_Skill_Groups_Logon_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_Logon_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_logon_name(inputs)
	return de_tables_skill_groups_logon_name(inputs)
});